import React from 'react';
import { translate } from 'react-i18next';
import { Segment, Container, Card, Image, Label, Icon, Header } from 'semantic-ui-react';

import {colors, fontSizes, fonts, spacings, layout} from 'style';
import ProgressBar from 'modules/misc/ProgressBar.js';
import Utils from 'utils/Utils.js';
import UserUtils from 'utils/UserUtils.js';

var style = {
    content: {
        ...fonts.body,
        lineHeight: '1.5',
        maxWidth: layout.screenWidth,
        boxShadow: layout.screenShadow,
        minHeight: '100%',
        backgroundColor:'white',
        marginLeft: 'auto',
        marginRight: 'auto',
    },
    body: {
        maxWidth: '100vw',
    },
    topRow: {
        textAlign: 'center',
        padding: spacings.base,
    },
    avatarLabelContainer: {
        width: '100%', 
        height:'32px'
    },
    avatarLabel: {
        textAlign: 'right',
        color: '#fff',
        backgroundColor: colors.themeBlue,
        fontWeight: 'normal',
        position: 'relative',
        width: '100px',
        paddingRight: '20px',
        borderRadius: '100px',
    },
    pointsLabel: {
        backgroundColor: colors.pointsYellow,
    },
    starIcon: {
        position: 'absolute',
        left: '6px',
        top: '6px',
        fontSize: '1.5em',
        opacity: '1',
        color: '#FFF'
    },
    resourceIcon: {
        position: 'absolute',
        left: '6px',
        top: '6px',
        fontSize: '1.3em',
        opacity: '1',
        color: '#FFF'
    },
    avatarCard: {
        display: 'inline-block',
        padding: '10px 15px 10px 15px',
        width: '520px',
        maxWidth: '100%',
        verticalAlign: 'middle',
    },
    name: {
        display: 'inline-block',
        color: colors.themeBlue,
        textAlign: 'center',
        overflow: 'visible',
    },
    team: {
        color: colors.themeBlue,
        textAlign: 'center',
    },
    cards: {
        justifyContent: 'center'
    },
    userMeta: {
        paddingBottom: '10px',
        color: colors.themeBlue,
        textAlign: 'center',
        fontSize: '1.2em',
    },
    avatarContainer: {
        position: 'relative',
        display: 'inline-block',
        minHeight: '150px',
        maxWidth: '50%',
        verticalAlign: 'top',
    },
    avatar: {
        width: '280px',
        borderRadius: '50%',
        cursor: 'pointer',
    },
    healthGradeContainer: {
        display: 'inline-block',
        verticalAlign: 'middle',
        paddingRight: '15px',
    },
    healthGradeLabel: {
        display: 'inline-block',
        marginBottom: '30px',
        width: '300px',
        backgroundColor: colors.themeTeal,
        color: '#fff',
        borderRadius: '20px',
        textAlign: 'center',
        padding: '10px',
    },
    healthGradeLabelIncomplete: {
        backgroundColor: colors.themeBlue,
    },
    healthGradeLabelComplete: {
        cursor: 'pointer'
    },
    healthGrade: {
        paddingTop: '20px',
        fontSize: '2em',
    },
    healthSphere: {
        float: 'left',
        fontSize: '1.4em',
    },
    pencilIcon: {
        float: 'right',
        fontSize: '1.4em',
    },
    startSurvey: {
        textAlign: 'center',
        height:'40px',
        lineHeight:'40px',
        borderRadius: '25px',
        backgroundColor: '#fff',
        color: colors.themeBlue, 
        margin:'5px 5px 5px 5px', 
        cursor: 'pointer',
    },
    profileInfo: {
        float: 'right',
        display: 'inline-block',
        marginRight: '4vw',
    },
    divider: {
        paddingTop: '20px',
        paddingBottom: '20px',
        color: colors.themeTeal,
        textAlign: 'center',
    },
    categoryContent: {
        paddingLeft: spacings.base,
        paddingRight: spacings.base,
        backgroundColor:'#fff',
    },
    categoryCard: {
        position: 'relative',
        paddingLeft: '80px',
        width: '400px',
        minHeight: '90px',
    },
    pseudoCard: {
        height: '0px',
        minHeight: '0px',
        border: 'none',
        boxShadow: 'none',
        visibility: 'hidden',
        marginTop: '0',
        marginBottom: '0',
    },
    categoryBadge: {
        position: 'absolute',
        top: '15px',
        left: '15px',
        width: '60px',
        height: '60px',
        backgroundPosition:'50% 50%', 
        backgroundSize:'cover',
    },
    defaultCategoryBadge: {
        top: '15px',
        width: '40px',
        height: '40px',
        fontSize: '40px',
        borderRadius: '50%',
        color:colors.themeDarkGrey,
    },
    title: {
        color: colors.themeTeal,
    },
    levelText: {
        fontSize: '0.95em',
    },
    activitiesComplete: {
        fontSize: '0.9em',
    }
}



const Profile = ({t, 
                  userProfile, 
                  userHealth, 
                  userRank,
                  userCategories, 
                  dataLoaded, 
                  onEditUser, 
                  onStartSurvey,
                  onEditSurvey}) => {
    if(!dataLoaded) {
        return null;
    }
    return (
        <div style={style.content}>
            <div style={style.body}>
                <div style={style.topRow}>
                    <div style={style.avatarCard}>
                        <div>
                            <span style={style.avatarContainer}>
                                <Image style={style.avatar} src={UserUtils.getAvatarURL(userProfile)} onClick={onEditUser}/>
                            </span>
                            <div style={style.profileInfo}>
                                <Header style={style.name}>{userProfile.firstName} {Utils.limitTo(userProfile.lastName, 1)}</Header>
                                <div style={{...style.userMeta, ...(Boolean(userRank) ? {} : {visibility:'hidden'})}}>
                                    {t('Ranked {{rank}}',{rank:userRank})}
                                </div>
                                <div style={style.team}>{userProfile.team.name || t('N/A')}</div>
                                <br />

                                <div style={style.avatarLabelContainer}><Label style={{...style.avatarLabel, ...style.pointsLabel}} size='large'><span style={{width:'20px'}}><Icon style={style.starIcon} className="notClickable icon-star"/></span><span className="bold"> </span><span className="right floated">{userProfile.points}</span></Label></div>
                                <div style={style.avatarLabelContainer}><Label style={style.avatarLabel} size='large'><span style={{width:'20px'}}><Icon style={style.resourceIcon} className="notClickable icon-Optimollar"/></span><span className="bold"> </span><span className="right floated">{userProfile.resources}</span></Label></div>
                            </div>
                        </div>
                    </div>
                    {(userHealth) &&
                        <div style={style.healthGradeContainer}>
                            {(userHealth.overall==null) ? (
                                <div style={{...style.healthGradeLabel, ...style.healthGradeLabelIncomplete}}>
                                    <i className='icon-myHealthSphere-logo' style={style.healthSphere}></i>
                                    {t('Your Health Grade')}
                                    <div style={style.healthGrade}>?</div>
                                    <br />
                                    { userHealth.survey && <div>
                                        <div>{t('need_to_complete_health_message',{title:userHealth.survey.title})}</div>
                                        <br />
                                        <div style={style.startSurvey} onClick={()=>onStartSurvey(userHealth.survey.tag, userHealth.micro)}>{t('Start Survey')}</div>
                                    </div> }
                                </div>
                                ) : (
                                <div style={{...style.healthGradeLabel, ...style.healthGradeLabelComplete}} onClick={()=>onEditSurvey(userHealth.survey.tag)}>
                                    <i className='icon-myHealthSphere-logo' style={style.healthSphere}></i>
                                    <i className='icon-pencil2' style={style.pencilIcon}></i>
                                    {t('Your Health Grade')}
                                    <div style={style.healthGrade}>{Number(userHealth.overall).toFixed(1)}</div>
                                    <br />
                                    {Boolean(userHealth.averageAgeSex) &&
                                        <div>{t('The average for your age and sex demograhic is {{value}}', {value:userHealth.averageAgeSex.toFixed(1)})}</div>
                                    }
                                </div>
                                )
                            }
                        </div>
                    }
                </div>

                <div style={style.categoryContent}>

                    <div style={style.divider}>{t('Daily Goals Overview')}</div>

                    <div>
                    <Card.Group style={style.cards}>

                        {userCategories.list
                            .map((id)=>(userCategories.indexed[id]))
                            .map((category)=>(
                                <Card key={category.id} style={style.categoryCard}>
                                    <Card.Content>
                                        {Boolean(category.badge) ? (
                                            <div style={{...style.categoryBadge, backgroundImage:Utils.url(category.badge.url)}} />
                                            ) : (
                                            <i style={{...style.categoryBadge, ...style.defaultCategoryBadge}} className='icon-myHealthSphere-logo' />
                                            )
                                        }
                                        <Card.Description style={style.title}>{category.title}</Card.Description>
                                        {Boolean(category.userCategory && category.userCategory.categoryLevel) &&
                                            <Card.Description style={style.levelText}>{t('progress_{{completed}}_{{required}}_{{level}}',{completed:category.userCategory.levelActivitiesCompleted, required:category.userCategory.categoryLevel.numRequired, level:category.userCategory.level})}</Card.Description>
                                        }
                                        {Boolean(category.userCategory && category.userCategory.categoryLevel) &&
                                            <ProgressBar value={category.userCategory.levelActivitiesCompleted} total={category.userCategory.categoryLevel.numRequired} />
                                        }
                                        {Boolean(category.userCategory) && 
                                            <Card.Description style={style.activitiesComplete}>{t('[count]_activity_completed',{count:category.userCategory.activitiesCompleted})}</Card.Description>
                                        }
                                    </Card.Content>
                                </Card>
                            ))
                        }
                        {/*hack to force left alignment of last row*/}
                        {[1,2,3,4].map(i=>(<Card key={i} style={{...style.categoryCard, ...style.pseudoCard}} />))}
                    </Card.Group>
                    </div>
                </div>
            </div>
        </div>
    );
}


export default translate('profile')(Profile);



// WEBPACK FOOTER //
// ./src/modules/profile/Profile.js